import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgFlashFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 15.05V21c0 .98 1.265 1.375 1.823.569l7-10.125a1 1 0 0 0-.604-1.545l-4.093-.92.864-5.832c.15-1.014-1.14-1.57-1.774-.767l-8 10.125a1 1 0 0 0 .564 1.596l4.22.949Z", fill: color }));
};
export default factorySvgIcon(SvgFlashFilled);
//# sourceMappingURL=SvgFlashFilled.js.map